module.exports = __webpack_public_path__ + "img/accessory_shirt_09.e0a1c5ce.svg";